<div class="full-width has-nav wrapper">
  <div class="container m-auto">
    <div class="logo">
      <svg
        version="1.1"
        id="Calque_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 283.5 255.1"
        style="enable-background: new 0 0 283.5 255.1"
        xml:space="preserve"
      >
        <style type="text/css">
          .st0 {
            fill: #3b5d4d;
          }
        </style>
        <g>
          <g>
            <g>
              <path
                class="st0"
                d="M137.2,167.7c0,0,0,0.1-0.1,0.2l-2.2,4.7c0,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.1,0-0.2-0.1l-0.1-0.1
				c-0.1-0.1-0.3-0.1-0.5-0.1h-12c-0.2,0-0.4-0.1-0.4-0.4v-0.7c0-0.2,0.1-0.4,0.4-0.4h0c1.3,0,1.7-1,1.7-2.3v-10.5
				c0-1.3-0.4-2.3-1.7-2.3h0c-0.2,0-0.4-0.1-0.4-0.4v-0.7c0-0.2,0.1-0.4,0.4-0.4h7.2c0.2,0,0.5,0.1,0.5,0.4v0.7
				c0,0.2-0.5,0.4-0.7,0.4h-1.5v12.5c0,1.3,0.4,2.2,1.6,2.3h0.9c1.7,0,3.6-0.2,5.7-3.6l0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.2
				c0,0,0.1,0,0.2,0l0.8,0.5C137.1,167.4,137.2,167.5,137.2,167.7z"
              />
              <path
                class="st0"
                d="M145.3,170.8c1,0,2.2-0.5,3.1-1.8c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,1,0.5c0.1,0,0.1,0.1,0.1,0.2
				c0,0.1-0.1,0.3-0.1,0.4c-0.9,1.7-2.4,2.8-4.8,2.8c-4,0-6.4-2.9-6.4-6.4c0-4.4,2.9-6.1,5.7-6.1c3.2,0,4.9,2.8,4.9,4.6
				c0,0.1,0,0.2-0.2,0.3l-6.9,3C142.3,169.5,143.5,170.8,145.3,170.8z M143.3,162.1c-1.3,0-2.1,1.2-2.1,2.7c0,0.5,0,1.3,0.2,1.8
				l3.8-1.9C145.3,163.2,144.4,162.1,143.3,162.1z"
              />
              <path
                class="st0"
                d="M160.2,164.3c-0.1,0-0.2,0-0.3-0.2c-1.4-1.8-3.1-2.5-4.3-2.5c-0.8,0-1.7,0.3-1.7,1.2c0,1.1,1.4,1.5,2.7,1.8
				c2.2,0.5,5.4,1.3,5.4,4.2c0,2.2-1.9,3.9-5,3.9c-1,0-2-0.2-2.8-0.6c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.1,0.4
				c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.3,0.2h-0.9c-0.2,0-0.3-0.1-0.4-0.2l-2.1-3.8c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0.1-0.2,0.2-0.3
				l0.7-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.2c1.6,2.3,3.5,3.2,5.4,3.2c1.5,0,2.3-0.5,2.3-1.4c0-1.2-2-1.7-3.6-2.2
				c-3.9-1.2-4.6-2.6-4.6-4.1c0-1.9,1.6-3.3,4.1-3.3c1.5,0,2.7,0.5,3.2,0.8c0,0,0.1,0,0.1,0c0.1,0,0.1-0.2,0-0.5c0-0.1,0-0.1,0-0.2
				c0-0.2,0.1-0.2,0.3-0.2h0.6c0.2,0,0.3,0.1,0.4,0.3l1.2,3c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2-0.2,0.3l-0.6,0.3
				C160.3,164.3,160.2,164.3,160.2,164.3z"
              />
            </g>
          </g>
          <g>
            <path
              class="st0"
              d="M25.5,202.4c1.8,0,3.8-0.9,5.2-3c0.1-0.1,0.2-0.2,0.3-0.2c0.2,0,0.3,0,1.6,0.8c0.1,0.1,0.2,0.2,0.2,0.3
			c0,0.2-0.1,0.5-0.2,0.7c-1.6,2.9-4.1,4.8-8.2,4.8c-6.8,0-11-5-11-10.9c0-7.6,4.9-10.5,9.7-10.5c5.4,0,8.4,4.8,8.4,7.9
			c0,0.2-0.1,0.4-0.4,0.5L19.3,198C20.3,200.2,22.3,202.4,25.5,202.4z M22.1,187.6c-2.3,0-3.6,2-3.6,4.7c0,0.8,0,2.2,0.4,3.2
			l6.6-3.3C25.5,189.5,24,187.6,22.1,187.6z"
            />
            <path
              class="st0"
              d="M57.2,203.4v1.2c0,0.4-0.2,0.6-0.6,0.6H46.1c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6h0.1
			c0.5,0,1.5-0.2,1.5-0.9c0-0.3-0.2-0.7-0.6-1.2l-3.5-4.3l-2.9,3.7c-0.7,1-1.2,1.7-1.2,2.1c0,0.3,0.3,0.5,1,0.5h0.8
			c0.4,0,0.6,0.2,0.6,0.6v1.2c0,0.4-0.2,0.6-0.6,0.6h-7.8v0c-0.2-0.1-0.3-0.3-0.3-0.6v-1.2c0-0.3,0.1-0.5,0.3-0.5v-0.1H34
			c1.7,0,2.3-0.8,3.6-2.5l4.4-5.7l-4-4.8c-1.4-1.7-2.6-2.6-3.6-2.6h-0.1c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6h10.3
			c0.4,0,0.6,0.2,0.6,0.6v1.2c0,0.4-0.2,0.6-0.6,0.6h-0.1c-1,0-1.5,0.2-1.5,0.6c0,0.3,0.2,0.7,0.7,1.3l2.7,3.4l2-2.7
			c0.8-1,1.2-1.7,1.2-2.1c0-0.3-0.3-0.5-1-0.5h-0.4c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6h7.5c0.4,0,0.6,0.2,0.6,0.6
			v1.2c0,0.4-0.2,0.6-0.6,0.6h-0.6c-1.7,0-2.2,0.7-3.6,2.5l-3.6,4.6l4.8,5.8c1.4,1.8,2.6,2.6,3.6,2.6h0.1
			C57,202.8,57.2,203,57.2,203.4z"
            />
            <path
              class="st0"
              d="M73.1,184.2c3.7,0,9.1,2.9,9.1,10.8c0,7.6-4.6,10.7-9.5,10.7c-2.1,0-3.9-0.7-5.3-1.9v3.3c0,2.2,1,3.9,3,3.9
			c0.4,0,0.6,0.2,0.6,0.6v1.2c0,0.4-0.2,0.6-0.6,0.6H58.6c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.7-0.6c2,0,3-1.7,2.9-3.9V193
			c0-2.2-0.1-4.5-2.4-4.7c-0.4,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.6-0.5c4.1,0,5.7-0.8,7.5-1.6c0.1,0,0.2-0.1,0.3-0.1h0.1
			c0,0,0,0,0,0.1l-0.5,3.6C67.3,186.9,68.9,184.2,73.1,184.2z M71.9,203.1c3.9,0,5-3.4,5-6.8c0-5.2-2.3-8.5-5.7-8.5
			c-3,0-3.9,2.7-3.9,2.7v7.5C67.6,200.6,69.2,203.1,71.9,203.1z"
            />
            <path
              class="st0"
              d="M95.4,202.8c0.4,0,0.6,0.2,0.6,0.6v1.2c0,0.4-0.2,0.6-0.6,0.6H83.6c-0.4,0-0.6-0.2-0.6-0.6v-1.2
			c0-0.4,0.2-0.6,0.6-0.6c2,0,3-1.7,3-3.9v-15.4c0-2.2-0.2-4.5-2.5-4.7c-0.4,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.4,0.6-0.5
			c4.3-1.4,6.6-3,7.7-3.8c0.1,0,0.1-0.1,0.2-0.1h0.1c0,0,0,0,0.1,0.1v26.3C92.3,201.1,93.4,202.8,95.4,202.8z"
            />
            <path
              class="st0"
              d="M107.2,184.3c4.1,0,8,2.4,9.8,6.5c0.7,1.5,1,3,1,4.5c0,4.1-2.3,7.9-6.1,9.6c-1.4,0.6-2.7,0.9-4.1,0.9
			c-4.1,0-8-2.4-9.8-6.5c-0.6-1.5-0.9-3-0.9-4.5c0-4.1,2.3-7.9,6.1-9.6C104.4,184.6,105.8,184.3,107.2,184.3z M101.8,192.3
			c0,1.5,0.5,3.2,1.1,4.8c1.3,2.9,3.5,5.4,6,5.4c0.5,0,1.1-0.1,1.6-0.4c1.8-0.8,2.5-2.4,2.5-4.3c0-1.5-0.5-3.2-1.1-4.8
			c-1.3-2.9-3.5-5.4-6-5.4c-0.5,0-1.1,0.1-1.6,0.4C102.5,188.7,101.8,190.4,101.8,192.3z"
            />
            <path
              class="st0"
              d="M135.4,184.3c2.5,0,4.6,1.4,4.6,4.2c0,1.2-0.1,2.2-1.1,2.6l-3.8,1.6c-0.1,0.1-0.2,0.1-0.4,0.1
			c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.4c0.3-0.8,0.4-1.5,0.4-2c0-1.5-0.8-2.1-1.9-2.1c-1.9,0-3.5,2-4.1,3.6v7.5
			c0,2.2,1,3.9,3,3.9h0.1c0.4,0,0.6,0.2,0.6,0.6v1.2c0,0.4-0.2,0.6-0.6,0.6H120c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6
			h0.1c2,0,3-1.7,3-3.9v-5.2c0-2.2-0.2-4.5-2.4-4.7c-0.4,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.6-0.5c3.9-0.6,7-2.2,8.1-3
			c0.1,0,0.1-0.1,0.2-0.1h0.1c0,0,0.1,0,0.1,0l-1,5.5C129.7,186,132.5,184.3,135.4,184.3z"
            />
            <path
              class="st0"
              d="M164.1,201.7c0.4,0,0.5,0.2,0.5,0.5v1.4c0,0.4-0.2,0.6-0.6,0.6c-4,0-5.7,0.7-7.5,1.6c-0.1,0-0.2,0.1-0.4,0.1
			H156c0,0,0,0,0-0.1l0.5-3.6c-0.5,1.1-2,3.8-6.2,3.8c-3.7,0-9.1-2.9-9.1-10.8c0-7.6,4.6-10.7,9.6-10.7c2.7,0,4.9,0.9,6.6,2.4
			c2.3-0.9,3.2-1.7,4.1-2.3c0,0,0.1-0.1,0.2-0.1h0.1c0,0,0,0,0,0.1v13.4C161.7,199.7,162.1,201.5,164.1,201.7z M151.4,187
			c-4,0-5,3.3-5,6.7c0,5.2,2.3,8.5,5.7,8.5c3,0,3.9-2.7,3.9-2.7v-8.2C155.7,189.6,154.6,187,151.4,187z"
            />
            <path
              class="st0"
              d="M180.8,202.7c0,0.2-0.1,0.3-0.3,0.5l-1.2,0.8c-1.5,0.9-3.7,1.9-5.8,1.9c-2.5,0-4.7-1.5-4.7-6.3v-7.6
			c0-2.2,0-4.7-3-4.7c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6h3v-2.7c0-0.3,0.1-0.6,0.4-0.7c1.2-0.7,3.4-2,5-3.4
			c0.1,0,0.1-0.1,0.2-0.1h0c0.1,0,0.1,0,0.1,0.1v6.9h5.5c0.4,0,0.6,0.2,0.6,0.6v1.8c0,0.4-0.2,0.6-0.6,0.6h-5.5v11.7
			c0,2.1,0.7,2.8,1.7,2.8c0.9,0,2-0.7,2.9-1.2h0c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0.1,0.5,0.3l0.7,1.1
			C180.7,202.5,180.8,202.6,180.8,202.7z"
            />
            <path
              class="st0"
              d="M194.2,202.4c1.8,0,3.8-0.9,5.2-3c0.1-0.1,0.2-0.2,0.3-0.2c0.2,0,0.3,0,1.6,0.8c0.1,0.1,0.2,0.2,0.2,0.3
			c0,0.2-0.1,0.5-0.2,0.7c-1.6,2.9-4.1,4.8-8.2,4.8c-6.8,0-11-5-11-10.9c0-7.6,4.9-10.5,9.7-10.5c5.4,0,8.4,4.8,8.4,7.9
			c0,0.2-0.1,0.4-0.4,0.5L188,198C189,200.2,191,202.4,194.2,202.4z M190.8,187.6c-2.3,0-3.6,2-3.6,4.7c0,0.8,0,2.2,0.4,3.2l6.6-3.3
			C194.1,189.5,192.7,187.6,190.8,187.6z"
            />
            <path
              class="st0"
              d="M227,201.7c0.4,0,0.5,0.2,0.5,0.5v1.4c0,0.4-0.2,0.6-0.6,0.6c-4,0-5.7,0.7-7.5,1.6c-0.1,0-0.2,0.1-0.3,0.1
			h-0.1c0,0,0,0,0-0.1l0.7-5.2c-1.1,2.3-3.6,5.3-7.4,5.3c-5.9,0-7-4-7-7.9v-6.8c0-2.2-1-3.9-3-3.9h-0.2c-0.4,0-0.6-0.2-0.6-0.6v-1.2
			c0-0.4,0.2-0.6,0.6-0.6h8.3c0.4,0,0.6,0.2,0.6,0.6v11.9c0,2.2-0.2,4.9,2.9,4.9c2,0,4.3-1.8,5-3.5v-7.6c0-2.2-1-3.9-3-3.9h-0.1
			c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6h8.2c0.4,0,0.6,0.2,0.6,0.6V197C224.6,199.2,224.8,201.5,227,201.7z"
            />
            <path
              class="st0"
              d="M245,184.3c2.5,0,4.6,1.4,4.6,4.2c0,1.2-0.1,2.2-1.1,2.6l-3.8,1.6c-0.1,0.1-0.2,0.1-0.4,0.1
			c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.4c0.3-0.8,0.4-1.5,0.4-2c0-1.5-0.8-2.1-1.9-2.1c-1.9,0-3.5,2-4.1,3.6v7.5
			c0,2.2,1,3.9,3,3.9h0.1c0.4,0,0.6,0.2,0.6,0.6v1.2c0,0.4-0.2,0.6-0.6,0.6h-11.9c-0.4,0-0.6-0.2-0.6-0.6v-1.2
			c0-0.4,0.2-0.6,0.6-0.6h0.1c2,0,3-1.7,3-3.9v-5.2c0-2.2-0.2-4.5-2.4-4.7c-0.4,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.6-0.5
			c3.9-0.6,7-2.2,8.1-3c0.1,0,0.1-0.1,0.2-0.1h0.1c0,0,0.1,0,0.1,0l-1,5.5C239.3,186,242.1,184.3,245,184.3z"
            />
            <path
              class="st0"
              d="M267,191.3c-0.2,0-0.4-0.1-0.5-0.3c-2.5-3.1-5.4-4.2-7.3-4.2c-1.4,0-2.9,0.5-2.9,2.1c0,1.8,2.3,2.5,4.6,3.1
			c3.8,0.9,9.2,2.2,9.2,7.1c0,3.9-3.3,6.7-8.6,6.7c-1.7,0-3.4-0.4-4.8-1.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0.2-0.2,0.6
			c0,0.1,0.1,0.2,0.1,0.3c0,0.2-0.2,0.4-0.5,0.3h-1.5c-0.3,0-0.5-0.1-0.7-0.4l-3.5-6.6c-0.1-0.1-0.1-0.2-0.1-0.4
			c0-0.2,0.1-0.4,0.3-0.5l1.3-0.7c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.3,0.1,0.5,0.3c2.7,4,5.9,5.5,9.3,5.5c2.5,0,3.9-0.8,3.9-2.3
			c0-2.1-3.4-2.9-6.2-3.7c-6.7-2-7.8-4.4-7.8-7.1c0-3.3,2.7-5.6,7-5.6c2.5,0,4.7,0.9,5.4,1.3c0,0,0.1,0.1,0.2,0.1
			c0.2,0,0.2-0.4,0-0.9c0-0.1,0-0.2,0-0.3c0-0.3,0.2-0.4,0.5-0.4h1.1c0.4,0,0.6,0.1,0.7,0.5l2,5.2c0.1,0.2,0.1,0.3,0.1,0.4
			c0,0.2-0.1,0.3-0.3,0.5l-1,0.5C267.2,191.3,267.1,191.3,267,191.3z"
            />
          </g>
          <g>
            <g>
              <g>
                <path
                  class="st0"
                  d="M138,239.4v1.2c0,0.4-0.2,0.6-0.6,0.6h-11.5c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6h0.2
					c1.7,0,2.1-1.3,2.1-3.9v-6.2c0-2.2,0.2-4.9-2.9-4.9c-2.4,0-4.1,1.7-5.3,3.9v7.2c0,3,1,3.9,2.6,3.9h0.3c0.4,0,0.6,0.2,0.6,0.6
					v1.2c0,0.4-0.2,0.6-0.6,0.6h-11.1c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6h0.3c1.1,0,2.2-0.9,2.2-3.9v-6.2
					c0-2.6,0.2-4.9-2.9-4.9c-2,0-4.3,1.8-5,3.5v7.5c0,2.2,1,3.9,2.6,3.9h0.1c0.4,0,0.6,0.2,0.6,0.6v1.2c0,0.4-0.2,0.6-0.6,0.6H97.4
					c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6h0.1c2,0,3-1.7,3-3.9v-5.2c0-2.2-0.2-4.5-2.5-4.7c-0.4,0-0.5-0.2-0.5-0.5
					v-1.4c0-0.3,0.2-0.5,0.6-0.5c3.9-0.6,7-2.2,8.1-3c0.1,0,0.1-0.1,0.2-0.1h0.1c0,0,0,0,0,0l-0.7,5.4c1.1-1.8,3.4-4.7,7.1-4.7
					c4,0,5.8,1.7,6.5,4c1.8-2.4,4.3-4,7.5-4c5.9,0,7,4,7,7.9v6.8c0,2.2,1,3.9,3,3.9h0.5C137.8,238.8,138,239,138,239.4z"
                />
                <path
                  class="st0"
                  d="M148.3,220.2c4.1,0,8,2.4,9.8,6.5c0.7,1.5,1,3,1,4.5c0,4.1-2.3,7.9-6.1,9.6c-1.4,0.6-2.7,0.9-4.1,0.9
					c-4.1,0-8-2.4-9.8-6.5c-0.6-1.5-0.9-3-0.9-4.5c0-4.1,2.3-7.9,6.1-9.6C145.6,220.5,147,220.2,148.3,220.2z M142.9,228.2
					c0,1.5,0.5,3.2,1.1,4.8c1.3,2.9,3.5,5.4,6,5.4c0.5,0,1.1-0.1,1.6-0.4c1.8-0.8,2.5-2.4,2.5-4.3c0-1.5-0.5-3.2-1.1-4.8
					c-1.3-2.9-3.5-5.4-6-5.4c-0.5,0-1.1,0.1-1.6,0.4C143.6,224.7,142.9,226.3,142.9,228.2z"
                />
                <path
                  class="st0"
                  d="M187.5,239.4v1.2c0,0.4-0.2,0.6-0.6,0.6h-11.1c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.7-0.6
					c1.6,0,2.2-1.7,2.1-3.9v-6.2c0-2.2,0.2-4.9-2.9-4.9c-2,0-4.3,1.8-5,3.5v7.5c0,2.2,1,3.9,3,3.9h0.1c0.4,0,0.6,0.2,0.6,0.6v1.2
					c0,0.4-0.2,0.6-0.6,0.6h-11.9c-0.4,0-0.6-0.2-0.6-0.6v-1.2c0-0.4,0.2-0.6,0.6-0.6h0.1c2,0,3-1.7,3-3.9v-5.2
					c0-2.2-0.2-4.5-2.4-4.7c-0.4,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.6-0.5c3.9-0.6,7-2.2,8.1-3c0.1,0,0.1-0.1,0.2-0.1h0.1
					c0,0,0.1,0,0.1,0l-0.7,5.4c1.1-1.8,3.3-4.7,7.1-4.7c5.9,0,7,4,7,7.9v6.8c0,2.2,1,3.9,3,3.9h0.2
					C187.3,238.8,187.5,239,187.5,239.4z"
                />
                <path
                  class="st0"
                  d="M210.6,237.6c0.4,0,0.5,0.2,0.5,0.5v1.4c0,0.4-0.2,0.6-0.6,0.6c-4,0-5.7,0.7-7.5,1.6
					c-0.1,0-0.2,0.1-0.3,0.1h-0.1c0,0,0,0,0-0.1l0.5-3.6c-0.5,1.1-2,3.8-6.2,3.8c-3.7,0-9.1-2.9-9.1-10.8c0-7.6,4.6-10.7,9.6-10.7
					c2,0,3.9,0.7,5.3,1.9v-2.6c0-2.2-0.2-4.5-2.4-4.7c-0.4,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.4,0.6-0.5c4.3-1.4,6.6-3,7.7-3.8
					c0,0,0.1-0.1,0.2-0.1h0.1c0,0,0,0,0,0.1v25.1C208.2,235.6,208.6,237.4,210.6,237.6z M197.9,223.3c-4,0-5,2.9-5,6.3
					c0,5.2,2.3,8.5,5.7,8.5c3,0,3.9-3.5,3.9-3.5v-6.7C202.1,225.4,200.6,223.3,197.9,223.3z"
                />
                <path
                  class="st0"
                  d="M224,238.3c1.8,0,3.8-0.9,5.2-3c0.1-0.1,0.2-0.2,0.3-0.2c0.2,0,0.3,0,1.6,0.8c0.1,0.1,0.2,0.2,0.2,0.3
					c0,0.2-0.1,0.5-0.2,0.7c-1.6,2.9-4.1,4.8-8.2,4.8c-6.8,0-11-5-11-10.9c0-7.6,4.9-10.5,9.7-10.5c5.4,0,8.4,4.8,8.4,7.9
					c0,0.2-0.1,0.4-0.4,0.5l-11.9,5.2C218.8,236.2,220.9,238.3,224,238.3z M220.7,223.5c-2.3,0-3.6,2-3.6,4.7c0,0.8,0,2.2,0.4,3.2
					l6.6-3.3C224,225.4,222.6,223.5,220.7,223.5z"
                />
              </g>
            </g>
            <g>
              <path
                class="st0"
                d="M68.5,239.2c0.3,0,0.3,0.2,0.3,0.4v1c0,0.3-0.1,0.4-0.4,0.4c-2.8,0-4,0.5-5.3,1.1c-0.1,0-0.1,0.1-0.2,0.1
				h-0.1c0,0,0,0,0-0.1l0.3-2.6c-0.3,0.8-1.4,2.7-4.4,2.7c-2.6,0-6.4-2-6.4-7.6c0-5.3,3.3-7.6,6.8-7.6c1.4,0,2.7,0.5,3.7,1.4v-1.8
				c0-1.6-0.1-3.1-1.7-3.3c-0.3,0-0.3-0.2-0.3-0.4v-1c0-0.2,0.2-0.3,0.4-0.4c3-1,4.7-2.1,5.4-2.7c0,0,0.1-0.1,0.1-0.1h0.1
				c0,0,0,0,0,0.1v17.7C66.9,237.8,67.1,239.1,68.5,239.2z M59.6,229.1c-2.8,0-3.6,2.1-3.6,4.4c0,3.7,1.6,6,4,6
				c2.1,0,2.8-2.5,2.8-2.5v-4.7C62.6,230.6,61.5,229.1,59.6,229.1z"
              />
              <path
                class="st0"
                d="M86.7,239.2c0.3,0,0.3,0.2,0.3,0.4v1c0,0.3-0.1,0.4-0.4,0.4c-2.8,0-4,0.5-5.3,1.1c-0.1,0-0.1,0.1-0.2,0.1H81
				c0,0,0,0,0-0.1l0.5-3.6c-0.8,1.6-2.6,3.7-5.2,3.7c-4.1,0-4.9-2.8-4.9-5.6v-4.8c0-1.6-0.7-2.7-2.1-2.7H69c-0.3,0-0.4-0.1-0.4-0.4
				v-0.9c0-0.3,0.1-0.4,0.4-0.4h5.9c0.3,0,0.4,0.1,0.4,0.4v8.4c0,1.6-0.1,3.4,2.1,3.4c1.4,0,3-1.2,3.5-2.5v-5.3
				c0-1.6-0.7-2.7-2.1-2.7h-0.1c-0.3,0-0.4-0.1-0.4-0.4v-0.9c0-0.3,0.1-0.4,0.4-0.4h5.8c0.3,0,0.4,0.1,0.4,0.4v8.2
				C85,237.4,85.1,239.1,86.7,239.2z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            class="st0"
            d="M147.4,102.4c0-0.6-0.4-1-1-1H91.2c-0.6,0-1,0.4-1,1s0.4,1,1,1h55.2C147,103.4,147.4,102.9,147.4,102.4z"
          />
          <path
            class="st0"
            d="M109.6,109.6c0-0.6-0.4-1-1-1H96.2c-0.6,0-1,0.4-1,1s0.4,1,1,1h12.4C109.2,110.6,109.6,110.1,109.6,109.6z"
          />
          <path
            class="st0"
            d="M113.6,108.6c-0.6,0-1,0.4-1,1s0.4,1,1,1h3.4c0.6,0,1-0.4,1-1s-0.4-1-1-1H113.6z"
          />
          <path
            class="st0"
            d="M145.2,130.2H138c-0.6,0-1,0.4-1,1s0.4,1,1,1h7.2c0.6,0,1-0.4,1-1S145.8,130.2,145.2,130.2z"
          />
          <path
            class="st0"
            d="M187,108.6h-15.9c-0.6,0-1,0.4-1,1s0.4,1,1,1H187c0.6,0,1-0.4,1-1S187.6,108.6,187,108.6z"
          />
          <path
            class="st0"
            d="M167.1,109.6c0-0.6-0.4-1-1-1H122c-0.6,0-1,0.4-1,1s0.4,1,1,1h44.1C166.7,110.6,167.1,110.1,167.1,109.6z"
          />
          <path
            class="st0"
            d="M131.6,116.8c0-0.6-0.4-1-1-1h-27.4c-0.6,0-1,0.4-1,1s0.4,1,1,1h27.4C131.2,117.8,131.6,117.3,131.6,116.8z"
          />
          <path
            class="st0"
            d="M135.6,115.8c-0.6,0-1,0.4-1,1s0.4,1,1,1h15.8c0.6,0,1-0.4,1-1s-0.4-1-1-1H135.6z"
          />
          <path
            class="st0"
            d="M180.1,115.8h-23.7c-0.6,0-1,0.4-1,1s0.4,1,1,1h23.7c0.6,0,1-0.4,1-1S180.6,115.8,180.1,115.8z"
          />
          <path
            class="st0"
            d="M142.8,124c0-0.6-0.4-1-1-1h-28.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h28.3C142.3,125,142.8,124.5,142.8,124z"
          />
          <path
            class="st0"
            d="M169.8,123h-23.1c-0.6,0-1,0.4-1,1s0.4,1,1,1h23.1c0.6,0,1-0.4,1-1S170.3,123,169.8,123z"
          />
          <path
            class="st0"
            d="M192.1,101.4h-40.7c-0.6,0-1,0.4-1,1s0.4,1,1,1h40.7c0.6,0,1-0.4,1-1S192.6,101.4,192.1,101.4z"
          />
          <path
            class="st0"
            d="M141.6,13c-29,0-53.2,20.8-58.5,48.3c0,0,0,0.1,0,0.1c-0.7,3.6-1.1,7.3-1.1,11.1c0,8,1.5,15.7,4.6,23
		c0,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0,0c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.4,0.1c0,0,0,0,0,0h8.6c0.6,0,1-0.4,1-1
		s-0.4-1-1-1h-2.8v-9.5c1.3,1.2,3.1,1.9,5.4,1.9c0.6,0,1-0.4,1-1s-0.4-1-1-1c-1.9,0-3.3-0.5-4.3-1.5c-0.6-0.7-0.9-1.5-1-2.2
		c1.3,1.2,3.1,1.7,5.3,1.7c0.6,0,1-0.4,1-1s-0.4-1-1-1c-0.3,0-0.5,0-0.8-0.1c2.2,0,3.9-0.7,5.2-1.8v15.6h-2c-0.6,0-1,0.4-1,1
		s0.4,1,1,1h56.1c0.6,0,1-0.4,1-1s-0.4-1-1-1h-24.2l5.4-5.3l1.8-1.8l14.4-13.9l1.5-1.5l0.5-0.5l1.3-1.2l1.8-1.7l3-2.9l5.4-5.2
		l-4.9,13.3c-0.2,0.5,0,1,0.4,1.2l13.9,8.3l-7,11.2h-8.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h33.4c0,0,0,0,0,0c0.1,0,0.3,0,0.4-0.1
		c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0,0,0,0,0,0c3.1-7.3,4.6-15,4.6-23
		C201.2,39.7,174.5,13,141.6,13z M199.2,71.2h-12.5l-8-8l18.7-5C198.5,62.4,199.1,66.8,199.2,71.2z M185.1,34.9l-31.3,26.3
		c-1.3-1.3-2.7-2.5-4.3-3.3l17.3-37.1C173.8,24.2,180,29,185.1,34.9z M147.6,57c-1.6-0.6-3.2-1-5-1.1V15c7.9,0.1,15.5,1.9,22.3,4.9
		L147.6,57z M140.6,15V56c-1.7,0.1-3.3,0.5-4.8,1l-17.3-37.1C125.3,16.9,132.8,15.2,140.6,15z M116.7,20.7L134,57.8
		c-1.7,0.9-3.1,2-4.4,3.3L98.2,34.8C103.3,29,109.6,24.1,116.7,20.7z M96.9,36.4l31.3,26.3c-0.9,1.3-1.7,2.7-2.3,4.2l-4.8-1.3
		l-18.6-18.7c-0.4-0.4-0.9-0.4-1.3-0.1l-12.8,10l-2.1-0.6C88.6,48.9,92.2,42.2,96.9,36.4z M125.2,69.6l-1.2-1.2l1.4,0.4
		C125.4,69,125.3,69.3,125.2,69.6z M85.9,58.2l0.6,0.2L85.7,59C85.7,58.7,85.8,58.5,85.9,58.2z M91.5,94.2h-3.2
		c-1-2.5-1.9-5.1-2.5-7.7c0.1,0,0.2,0.1,0.3,0.1c2.3,0,4.1-0.6,5.4-1.9V94.2z M97.8,78.5c-0.6,0-1,0.4-1,1c0,0.5,0.3,0.9,0.8,1
		c-1.3-0.2-2.3-0.7-3-1.4c-0.6-0.7-0.9-1.5-1-2.2C94.6,77.7,96.1,78.3,97.8,78.5C97.8,78.5,97.8,78.5,97.8,78.5z M97.6,76.4
		c-1.3-0.2-2.3-0.7-3-1.4c-0.5-0.6-0.8-1.3-1-2c1,0.9,2.2,1.4,3.7,1.6c-0.3,0.2-0.5,0.5-0.5,0.9C96.8,75.9,97.2,76.3,97.6,76.4z
		 M102.1,76.9c-0.6,0.7-1.5,1.1-2.6,1.4c0.2-0.2,0.4-0.5,0.4-0.8c0-0.6-0.4-1-1-1c-0.3,0-0.5,0-0.8-0.1c2.1,0,3.8-0.6,5.1-1.7
		C103,75.4,102.7,76.3,102.1,76.9z M136.3,88.3l-6.1,5.9h-25V78.6c1.3,1.2,3.1,1.9,5.4,1.9c0.6,0,1-0.4,1-1s-0.4-1-1-1
		c-1.9,0-3.3-0.5-4.2-1.5c-0.6-0.7-0.9-1.5-1-2.2c1.3,1.2,3.1,1.7,5.3,1.7c0.6,0,1-0.4,1-1s-0.4-1-1-1c-1.9,0-3.3-0.5-4.2-1.5
		c-0.6-0.7-0.9-1.5-1-2.2c1.3,1.2,3.1,1.7,5.3,1.7c0.6,0,1-0.4,1-1s-0.4-1-1-1c-1.9,0-3.3-0.5-4.2-1.5c-0.5-0.6-0.8-1.3-1-2
		c1.3,1.1,3,1.7,5.2,1.7c0.6,0,1-0.4,1-1s-0.4-1-1-1c-1.9,0-3.3-0.5-4.2-1.5c-0.5-0.5-0.7-1.1-0.9-1.7c-0.1-0.4-0.2-0.8-0.2-1.2
		c0-0.4,0-0.7,0-0.9c0-0.3,0-0.5,0-0.5c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1
		c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0
		c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0.1
		c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0
		c0,0,0,0,0,0c0,0.1-0.1,0.6,0,1.4c0,0.2,0,0.4-0.1,0.6c-0.1,0.8-0.4,1.6-1.1,2.3c-0.9,1-2.3,1.5-4.3,1.5c-0.6,0-1,0.4-1,1
		s0.4,1,1,1c2.2,0,4-0.6,5.2-1.7c-0.2,0.7-0.5,1.4-1,2c-0.9,1-2.3,1.5-4.3,1.5c-0.6,0-1,0.4-1,1s0.4,1,1,1c2.2,0,4-0.6,5.3-1.7
		c-0.1,0.7-0.4,1.5-1,2.2c-0.6,0.6-1.4,1.1-2.4,1.3c0.1-0.2,0.2-0.3,0.2-0.5c0-0.6-0.4-1-1-1c-1.9,0-3.3-0.5-4.3-1.5
		c-0.8-0.9-1.1-2.1-1.1-2.9c0.1-0.8,0-1.4,0-1.4c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1
		c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0
		c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0.1
		c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1
		c0,0.1-0.1,0.6,0,1.4c-0.1,0.9-0.3,2-1.1,2.9c-0.9,1-2.3,1.5-4.2,1.5c-0.6,0-1,0.4-1,1s0.4,1,1,1c2.2,0,4-0.6,5.2-1.7
		c-0.2,0.7-0.5,1.4-1,2c-0.9,1-2.3,1.5-4.2,1.5c-0.6,0-1,0.4-1,1s0.4,1,1,1c2.2,0,4-0.6,5.3-1.7c-0.1,0.7-0.4,1.5-1,2.2
		c-0.9,1-2.3,1.5-4.2,1.5c-0.6,0-1,0.4-1,1s0.4,1,1,1c2.2,0,4-0.6,5.3-1.7c-0.1,0.7-0.4,1.5-1,2.2c-0.9,1-2.3,1.5-4.2,1.5
		c-0.3,0-0.5,0.1-0.7,0.3c-0.9-4-1.3-8.1-1.3-12.2c0-3.6,0.3-7.1,1-10.5L89,59l2-1.5l10.9-8.5l15.6,15.6l2.8,2.8l4.8,4.8l2.1,2.1
		l11.7,11.7l-0.8,0.8L136.3,88.3z M140.2,84.5L127,71.4c0.1-0.7,0.2-1.4,0.3-2.1c0.2-0.7,0.3-1.3,0.6-1.9c0.5-1.2,1.1-2.4,1.9-3.4
		c0.4-0.5,0.8-1.1,1.3-1.5c1.1-1.1,2.3-2.1,3.7-2.8c0.6-0.3,1.2-0.6,1.8-0.8c1.3-0.5,2.6-0.8,4-0.8c0.3,0,0.7-0.1,1-0.1s0.7,0,1,0.1
		c1.4,0.1,2.8,0.4,4.1,0.9c0.6,0.2,1.2,0.5,1.8,0.8c1.4,0.7,2.6,1.7,3.7,2.8c0.5,0.5,0.9,1,1.3,1.5c0.7,1,1.4,2.2,1.8,3.4
		c0.2,0.6,0.4,1.2,0.6,1.9l0,0l-2,1.9l-2.1,2L140.2,84.5z M158.8,66.5l-1.6,0.4c-0.5-1.5-1.3-2.9-2.2-4.1l31.4-26.3
		c4.7,5.8,8.3,12.5,10.4,19.8l-19.7,5.3l-5.8-5.8c0,0,0,0,0,0c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0
		c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1L158.8,66.5z
		 M195,94.2h-22.1l6.9-11c0.1-0.2,0.2-0.5,0.1-0.8c-0.1-0.3-0.2-0.5-0.5-0.6l-14.1-8.4l5.6-15.2l3.9,3.9l1.6,1.6l7.4,7.4l2,2
		l11.9,12C197.1,88.3,196.2,91.3,195,94.2z M198.3,82.9l-9.6-9.7h10.5C199.2,76.5,198.8,79.8,198.3,82.9z"
          />
        </g>
      </svg>
    </div>
    <div>
      @if (loading) {
      <p>Désinscription en cours</p>
      } @else {
      <p>{{ message }}</p>
      <div class="link">
        <img
          loading="lazy"
          class="icon"
          alt="plus"
          ngSrc="/icons/plus.svg"
          width="12"
          height="12"
        />
        <a href="/contact">
          <ng-container>Contacte-nous</ng-container>
          <div class="line"></div>
        </a>
      </div>
      }
    </div>
  </div>
</div>
